import React from "react";
import { Spinner } from "reactstrap";
import { useMonthlyUsers } from "../../Hooks/useMonthlyUsers";

const MONTHS = 6;

const format = (value) => (value ?? 0).toLocaleString("es-CO");

/**
 * Usuarios por mes: seis filas con barra doble nuevos/activos.
 *
 * Sustituye a la gráfica de apexcharts que había aquí. Con seis meses y dos
 * series, una barra por fila se lee de un vistazo y no necesita ejes: el
 * número exacto va escrito al lado, que era lo que la gente miraba de todos
 * modos. Los datos son los mismos de `useMonthlyUsers`.
 */
const UsersComparisonChart = () => {

    const { rows, totals, isLoading } = useMonthlyUsers(MONTHS);

    // La escala es común a las seis filas: si cada fila se normalizara contra
    // sí misma, todos los meses se verían iguales y la comparación —que es
    // para lo que está la tarjeta— desaparecería.
    const max = Math.max(
        1,
        ...rows.map((row) => Math.max(row.new_users ?? 0, row.active_users ?? 0))
    );

    const width = (value) => `${((value ?? 0) / max) * 50}%`;

    return (
        <div className="ui-card">

            <div className="ui-card__head" style={{ marginBottom: 20 }}>
                <div>
                    <h2 className="ui-card__title">Usuarios por mes</h2>
                    <div className="ui-card__sub">Nuevos vs. activos</div>
                </div>

                {totals?.retention_percentage !== null &&
                    totals?.retention_percentage !== undefined && (
                    <span className="ui-chip ui-chip--success">
                        {totals.retention_percentage}% retención
                    </span>
                )}
            </div>

            {isLoading ? (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                </div>
            ) : rows.length === 0 ? (
                <div className="ui-empty">Todavía no hay meses con datos.</div>
            ) : (
                <div className="ui-barlist">
                    {rows.map((row) => (
                        <div key={row.month}>
                            <div className="ui-barlist__head">
                                <span className="ui-barlist__month">{row.month}</span>
                                <span className="ui-barlist__meta">
                                    <b style={{ color: "#4B36F0" }}>{format(row.new_users)}</b> nuevos
                                    {" · "}
                                    <b style={{ color: "#0F9A5A" }}>{format(row.active_users)}</b> activos
                                </span>
                            </div>
                            <div className="ui-barlist__track">
                                <div
                                    className="ui-barlist__a"
                                    style={{ width: width(row.new_users) }}
                                />
                                <div
                                    className="ui-barlist__b"
                                    style={{ width: width(row.active_users) }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}

        </div>
    );

};

export default UsersComparisonChart;
